import { Alert, AlertId } from '../types';

export const Alerts: { [key in AlertId]: Alert } = {
	'sign-out': {
		label: 'auth.alert.sign-out.success.label',
		content: 'auth.alert.sign-out.success.content',
		appearance: 'positive',
	},
	'sign-out-error': {
		label: 'auth.alert.sign-out.error.label',
		content: 'auth.alert.sign-out.error.content',
		appearance: 'negative',
	},
	'sign-in-error': {
		label: 'auth.alert.sign-in.error.label',
		content: 'auth.alert.sign-in.error.content',
		appearance: 'negative',
	},
	'generic-error': {
		label: 'data.alert.generic.error.label',
		content: 'data.alert.generic.error.content',
		appearance: 'negative',
	},
	'generic-success': {
		label: 'data.alert.generic.success.label',
		content: 'data.alert.generic.success.content',
		appearance: 'positive',
	},
	'analysis-deleted-error': {
		label: 'analysis.alert.analysis-deleted-error.label',
		content: 'analysis.alert.analysis-deleted-error.content',
		appearance: 'negative',
	},
	'analysis-expired-error': {
		label: 'analysis.alert.analysis-expired-error.label',
		content: 'analysis.alert.analysis-expired-error.content',
		appearance: 'negative',
	},
	'analysis-not-found-error': {
		label: 'analysis.alert.analysis-not-found-error.label',
		content: 'analysis.alert.analysis-not-found-error.content',
		appearance: 'negative',
	},
	'analysis-processing-success': {
		label: 'analysis.alert.analysis-processing-success.label',
		content: 'analysis.alert.analysis-processing-success.content',
		appearance: 'positive',
	},
	'analysis-processing-complete': {
		label: 'analysis.alert.analysis-processing-complete.label',
		content: 'analysis.alert.analysis-processing-complete.content',
		appearance: 'positive',
	},
	'analysis-link-copied-success': {
		label: 'analysis.alert.analysis-link-copied-success.label',
		content: 'analysis.alert.analysis-link-copied-success.content',
		appearance: 'positive',
	},
	'analysis-link-copied-error': {
		label: 'analysis.alert.analysis-link-copied-error.label',
		content: 'analysis.alert.analysis-link-copied-error.content',
		appearance: 'negative',
	},
	'report-link-copied-success': {
		label: 'report.alert.report-link-copied-success.label',
		content: 'report.alert.report-link-copied-success.content',
		appearance: 'positive',
	},
	'report-link-copied-error': {
		label: 'report.alert.report-link-copied-error.label',
		content: 'report.alert.report-link-copied-error.content',
		appearance: 'negative',
	},
	'analysis-access-denied': {
		label: 'analysis.alert.analysis-access-denied.label',
		content: 'analysis.alert.analysis-access-denied.content',
		appearance: 'negative',
	},
	'report-access-denied': {
		label: 'report.alert.report-access-denied.label',
		content: 'report.alert.report-access-denied.content',
		appearance: 'negative',
	},
	'report-edit-access-denied': {
		label: 'report.alert.report-edit-access-denied.label',
		content: 'report.alert.report-edit-access-denied.content',
		appearance: 'negative',
	},
	'report-error-not-editable': {
		label: 'report.alert.report-error-not-editable.label',
		content: 'report.alert.report-error-not-editable.content',
		appearance: 'negative',
	},
	'report-error-approved': {
		label: 'report.alert.report-error-approved.label',
		content: 'report.alert.report-error-approved.content',
		appearance: 'negative',
	},
	'report-error-status-changed': {
		label: 'report.alert.report-error-status-changed.label',
		content: 'report.alert.report-error-status-changed.content',
		appearance: 'negative',
	},
	'report-error-status-updated': {
		label: 'report.alert.report-error-status-updated.label',
		content: 'report.alert.report-error-status-updated.content',
		appearance: 'warning',
	},
};
